import React from 'react'
import './SendMail.css'
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { CloseSendMessage } from './features/mailSlice';
import firebase from 'firebase';
import { db } from './firebase';

function SendMail() {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const onSubmit = (formdata) => {
        db.collection("emails").add({
            to : formdata.to,
            subject :formdata.subject,
            message: formdata.message,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
        dispatch(CloseSendMessage());
    };
    const dispatch = useDispatch();

  return (
    <div className='sendmail'>
        <div className='sendmail_header'>
            <h3>New Message</h3>
            <CloseIcon className='sendmail_close' onClick={()=>dispatch(CloseSendMessage())}/>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
            <input  type="email"  placeholder='To' {...register("to", { required: true})}/>
            <input  type="text" placeholder='Subject' {...register("subject", { required: true })}/>
            <input  type="text" placeholder='Message' className='sendmail_message' {...register("message", { required: true })}/>
            <div className='sendmail_option'>
                <Button className='sendmal_button' variant='contained' color='primary' type='submit'>Send</Button>
            </div>
        </form>
    </div>
  )
}

export default SendMail